import { EUserFieldNames, IUserRole } from "src/services/users/userTypes";
import { IAction } from "../../configs/types";
import { EUserActionTypes } from "./userAction";

export interface IUserState {
  [EUserFieldNames.ID]: null | number;
  [EUserFieldNames.FirstName]: string;
  [EUserFieldNames.LastName]: string;
  [EUserFieldNames.Email]: string;
  [EUserFieldNames.Username]: string;
  [EUserFieldNames.EmployeeCode]: string;
  [EUserFieldNames.Roles]: IUserRole[];
  notification?: {
    message: string;
    type: "success" | "error";
  } | null;
}

const initialState: IUserState = Object.freeze({
  [EUserFieldNames.ID]: null,
  [EUserFieldNames.EmployeeCode]: "",
  [EUserFieldNames.FirstName]: "",
  [EUserFieldNames.LastName]: "",
  [EUserFieldNames.Username]: "",
  [EUserFieldNames.Roles]: [],
  [EUserFieldNames.Email]: "",
  notification: null,
});

export default function userReducer(
  state = initialState,
  action: IAction<EUserActionTypes, IUserState>,
) {
  switch (action.type) {
    case EUserActionTypes.SignIn:
      return {
        ...state,
        ...(action.payload as IUserState),
      };
    case EUserActionTypes.SignOut:
      localStorage.removeItem("token");
      localStorage.removeItem("tokenIssuedAt");
      localStorage.removeItem("tokenExpiresIn");
      return {
        ...initialState,
      };
    case EUserActionTypes.SetNotification:
      return {
        ...state,
        notification: action.payload,
      };
    default:
      return state;
  }
}
